export default "__VITE_ASSET__81c37cf3__"